// Chart patterns — RE₿EL LLM pipeline translation (Sprint B).
// tipo/direccion/nivel keys preserved from ES for filter consistency.

export const PATRONES = [
  {
    id: "bandera-alcista",
    nombre: "看涨旗形",
    tipo: "continuacion",
    direccion: "alcista",
    nivel: "basico",
    descripcion: "看涨持续形态，由强劲的上涨冲动（旗杆）后跟随平行下降通道内的回调（旗面）组成。表示趋势继续上涨前的暂停。",
    estructura: [
      "旗杆：强劲的看涨冲动",
      "平行下降修正通道（旗面）",
      "伴随交易量向上突破通道"
    ],
    objetivo: "从突破点向上投射旗杆的高度。",
    consejo: "寻找旗面期间交易量递减，突破时交易量增加。在4小时或日线时间框架更可靠。在积极消息后BTC中非常常见。"
  },
  {
    id: "bandera-bajista",
    nombre: "看跌旗形",
    tipo: "continuacion",
    direccion: "bajista",
    nivel: "basico",
    descripcion: "看跌持续形态。强劲的下降冲动（旗杆）后跟随平行通道内的上涨回调（旗面）。看跌趋势持续的信号。",
    estructura: [
      "旗杆：强劲的看跌冲动",
      "平行上涨修正通道",
      "向下突破通道"
    ],
    objetivo: "从突破点向下投射旗杆的高度。",
    consejo: "修正通道应保持在旗杆50%以下。如果超过该水平，形态可靠性降低。"
  },
  {
    id: "banderin-alcista",
    nombre: "看涨三角旗",
    tipo: "continuacion",
    direccion: "alcista",
    nivel: "basico",
    descripcion: "类似于看涨旗形，但回调形成收敛三角形而非平行通道。盘整更紧凑，突破通常更具爆发力。",
    estructura: [
      "旗杆：看涨冲动",
      "收敛三角形盘整",
      "向上突破三角形"
    ],
    objetivo: "从三角形顶点向上投射旗杆的高度。",
    consejo: "三角形应在旗杆上半部分形成。突破越接近顶点，运动通常越强劲。"
  },
  {
    id: "banderin-bajista",
    nombre: "看跌三角旗",
    tipo: "continuacion",
    direccion: "bajista",
    nivel: "basico",
    descripcion: "三角旗的看跌版本。收敛三角形在强劲看跌冲动后形成。持续信号：向下突破确认运动。",
    estructura: [
      "旗杆：看跌冲动",
      "收敛三角形盘整",
      "向下突破三角形"
    ],
    objetivo: "从顶点向下投射旗杆的高度。",
    consejo: "通过突破时交易量增加来确认。短时间框架（15分钟-1小时）的三角旗在加密货币中非常常见。"
  },
  {
    id: "taza-asa",
    nombre: "杯柄形态",
    tipo: "continuacion",
    direccion: "alcista",
    nivel: "intermedio",
    descripcion: "U形平滑回调（杯身）后跟随小幅看跌盘整（手柄）。这是牛市中研究最多的形态之一。",
    estructura: [
      "前期看涨冲动",
      "U形回调（杯身）",
      "小幅看跌回调（手柄）",
      "突破阻力位上方"
    ],
    objetivo: "杯身深度从阻力位向上投影。",
    consejo: "杯身应呈圆形（U形），而非V形。手柄回调不应超过杯身深度的50%。在BTC周线图上非常常见。"
  },
  {
    id: "taza-asa-invertida",
    nombre: "倒杯柄形态",
    tipo: "continuacion",
    direccion: "bajista",
    nivel: "intermedio",
    descripcion: "看跌版本。回调形成倒圆顶，随后出现小幅看涨回调。看跌延续信号。",
    estructura: [
      "前期看跌冲动",
      "倒U形回调（圆顶）",
      "小幅看涨回调（手柄）",
      "支撑位看跌突破"
    ],
    objetivo: "圆顶深度从支撑位向下投影。",
    consejo: "在长期熊市中常见。确认突破下行时交易量增加。"
  },
  {
    id: "doble-techo",
    nombre: "双顶",
    tipo: "reversion",
    direccion: "bajista",
    nivel: "basico",
    descripcion: "两个连续高点位于同一水平，中间有一个低点。表明买方无法突破该阻力位。跌破颈线确认反转。",
    estructura: [
      "第一个高点",
      "回调至颈线",
      "第二个高点位于同一水平",
      "颈线看跌突破"
    ],
    objetivo: "高点与颈线之间的距离向下投影。",
    consejo: "第二个高点交易量较低会提高可靠性。确认收盘价低于颈线。"
  },
  {
    id: "doble-suelo",
    nombre: "双底",
    tipo: "reversion",
    direccion: "alcista",
    nivel: "basico",
    descripcion: "两个连续低点位于同一水平，中间有一个高点。卖方无法将价格推低至该支撑位下方。颈线看涨突破确认反转。",
    estructura: [
      "第一个低点",
      "反弹至颈线",
      "第二个低点位于同一水平",
      "颈线看涨突破"
    ],
    objetivo: "低点与颈线之间的距离向上投影。",
    consejo: "第二个低点交易量较低是积极信号。确认收盘价高于颈线。"
  },
  {
    id: "triple-techo",
    nombre: "三重顶",
    tipo: "reversion",
    direccion: "bajista",
    nivel: "intermedio",
    descripcion: "三个相同水平的高点。比双顶更可靠。每次未能突破阻力位都会增加卖压。",
    estructura: [
      "三个连续的相同水平高点",
      "两次中间回调",
      "跌破颈线"
    ],
    objetivo: "高点与颈线之间的距离，向下投影。",
    consejo: "形成时间越长，后续下跌通常越强劲。"
  },
  {
    id: "triple-suelo",
    nombre: "三重底",
    tipo: "reversion",
    direccion: "alcista",
    nivel: "intermedio",
    descripcion: "三个相同水平的低点。最强劲的看涨反转信号之一。每次反弹都会强化支撑位。",
    estructura: [
      "三个连续的相同水平低点",
      "两次中间反弹",
      "突破颈线上方"
    ],
    objetivo: "低点与颈线之间的距离，向上投影。",
    consejo: "在加密货币中，长期支撑位上的三重底经常标志着重要的市场底部。"
  },
  {
    id: "cabeza-hombros",
    nombre: "头肩顶",
    tipo: "reversion",
    direccion: "bajista",
    nivel: "basico",
    descripcion: "最著名的反转形态。三个高点：中间的（头部）高于两侧相同水平的（肩部）。跌破颈线确认看跌反转。",
    estructura: [
      "左肩",
      "头部（更高的高点）",
      "右肩（≈与左肩相同水平）",
      "颈线 + 看跌突破"
    ],
    objetivo: "头部与颈线之间的距离，从突破点向下投影。",
    consejo: "颈线向上倾斜更加看跌。突破时交易量放大确认形态。"
  },
  {
    id: "cabeza-hombros-inversos",
    nombre: "头肩底",
    tipo: "reversion",
    direccion: "alcista",
    nivel: "basico",
    descripcion: "头肩顶的看涨版本。三个低点，中间的（头部）最低。突破颈线上方标志着强劲的看涨反转。",
    estructura: [
      "左肩",
      "头部（更低的低点）",
      "右肩（≈与左肩相同水平）",
      "颈线 + 看涨突破"
    ],
    objetivo: "头部与颈线之间的距离，向上投影。",
    consejo: "识别底部最可靠的形态之一。寻找右肩和突破时交易量增加。"
  },
  {
    id: "cuna-ascendente",
    nombre: "上升楔形",
    tipo: "reversion",
    direccion: "bajista",
    nivel: "intermedio",
    descripcion: "向上倾斜的收敛通道。两条线都上升但收敛：价格上涨空间越来越小。看跌反转信号。",
    estructura: [
      "看涨阻力线",
      "看涨支撑线（斜率更大）",
      "两条线收敛",
      "向下突破"
    ],
    objetivo: "从突破点向下投射楔形底部的高度。",
    consejo: "上升楔形经常出现在看涨冲动的末端。是机构派发的信号。"
  },
  {
    id: "cuna-descendente",
    nombre: "下降楔形",
    tipo: "reversion",
    direccion: "alcista",
    nivel: "intermedio",
    descripcion: "向下倾斜的收敛通道。每次低点卖压都在减少。看涨反转信号：向上突破通常很强劲。",
    estructura: [
      "看跌阻力线",
      "看跌支撑线（斜率较小）",
      "两条线收敛",
      "向上突破"
    ],
    objetivo: "从突破点向上投射楔形底部的高度。",
    consejo: "在看涨趋势的回调中出现的下降楔形是BTC/ETH中非常可靠的延续信号。"
  },
  {
    id: "triangulo",
    nombre: "对称三角形",
    tipo: "neutro",
    direccion: "neutro",
    nivel: "basico",
    descripcion: "高点递减、低点递增的盘整区域。价格压缩直到能量产生突破。突破方向决定目标。",
    estructura: [
      "看跌阻力线",
      "看涨支撑线",
      "向顶点收敛",
      "突破（方向不确定）"
    ],
    objetivo: "三角形底部的高度向突破方向投射。",
    consejo: "背景决定概率：看涨趋势中的三角形通常向上突破。始终用K线收盘在外确认。"
  },
  {
    id: "rectangulo",
    nombre: "矩形",
    tipo: "neutro",
    direccion: "neutro",
    nivel: "basico",
    descripcion: "价格在水平支撑位和阻力位之间震荡。吸筹或派发区域。突破方向决定倾向和目标。",
    estructura: [
      "水平阻力位",
      "水平支撑位",
      "在两者之间震荡",
      "突破（方向不确定）"
    ],
    objetivo: "矩形高度向突破方向投射。",
    consejo: "在加密货币中，低点交易量增加的长矩形通常预示强劲的看涨突破（机构吸筹）。"
  }
];

export const TIPOS = ["continuacion", "reversion", "neutro"];
export const NIVELES = ["basico", "intermedio"];

export const TIPO_LABEL = {
  continuacion: "延续形态",
  reversion: "反转形态",
  neutro: "中性形态",
};

export const DIRECCION_LABEL = {
  alcista: "看涨",
  bajista: "看跌",
  neutro: "中性",
};

export const NIVEL_LABEL = {
  basico: "基础",
  intermedio: "中级",
};

export function getPatron(id) {
  return PATRONES.find((p) => p.id === id) || null;
}

export function filtrarPatrones(tipo, nivel) {
  return PATRONES.filter((p) => {
    const okTipo = !tipo || tipo === "todos" || p.tipo === tipo;
    const okNivel = !nivel || nivel === "todos" || p.nivel === nivel;
    return okTipo && okNivel;
  });
}
